class VideoObserver {
  constructor() {
    this.options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };
  }

  init() {
    document.querySelectorAll('.video-section-poster').forEach((poster) => {
      poster.addEventListener('click', () => this.handlePosterClick(poster));
    });
  }

  handlePosterClick(poster) {
    setTimeout(() => {
      const video = this.getVideoElement(poster);
      if (video && !video.dataset.observed) {
        this.createObserver(video);
        video.dataset.observed = 'true'; // Prevent multiple observers on the same video
      }
    }, 500);
  }

  getVideoElement(poster) {
    return poster
      .closest('deferred-media')
      ?.querySelector('video, .js-youtube, .js-vimeo');
  }

  createObserver(video) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => this.handleIntersection(entry));
    }, this.options);

    observer.observe(video);
  }

  handleIntersection(entry) {
    const target = entry.target;

    if (target.matches('video')) {
      entry.isIntersecting ? target.play() : target.pause();
    } else if (target.matches('.js-youtube')) {
      target.contentWindow.postMessage(
        `{"event":"command","func":"${
          entry.isIntersecting ? 'playVideo' : 'pauseVideo'
        }","args":""}`,
        '*'
      );
    } else if (target.matches('.js-vimeo')) {
      target.contentWindow.postMessage(
        { method: entry.isIntersecting ? 'play' : 'pause' },
        '*'
      );
    }
  }
}

const videoObserver = new VideoObserver();
videoObserver.init();
